import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationUser, AuthService, FavouritePortfolioLink, ResponseObject } from '../auth.service';
import { ServiceBase } from '../service.base';
import { environment } from 'src/environments/environment';
import { ArtistProductSummary } from '../artistproducts.service';
import { ArtistProduct } from 'src/app/models/artistproduct.model';

@Injectable({
  providedIn: 'root',
})
export class ArtistPortfolioProductsService extends ServiceBase {
  private api = '/ArtistProductPortfolio';
  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }
  // Fetches portfolio data
  public getPortFolioData(): Observable<portfolioData[]> {
    const httpOptions = this.RequestHeaders();
    const method = '/get-portfolios';
    const url = environment.BASE_API_PATH + this.api + method;
    return this.http.get<portfolioData[]>(url, httpOptions);
  }

  public downloadPortFolioData(PorfoliolinkId: string): Observable<Blob> {
    const httpOptions = this.RequestHeaders();
    const method = `/download-json-file-of-portfolio-products/${PorfoliolinkId}`;
    const url = environment.BASE_API_PATH + this.api + method;
    return this.http.get(url, { responseType: 'blob' });
  }

  // Saves or updates portfolio data
  public portfolioData(portfolioData: portfolioData): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/save-portfolio';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, portfolioData, httpOptions);
  }
  // Fetches the list of products for a shareable link
  public getArtistProtfolioProduct(shareablelinkId: string): Observable<ShareableProductLink> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/fetch-portfolio-products/${shareablelinkId}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ShareableProductLink>(url, httpOptions);
  }

  public savePortfolioProducts(request: SavePortfolioProducts): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/save-update-portfolio-products';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, request, httpOptions);
  }

  public updatePortfolioConfigrations(shareableLinkId: string, numberOfColumnToShow: number | null, isShowProfile: boolean): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/update-portfolio-Link-configuration';
    const url: string = environment.BASE_API_PATH + this.api + method;
    const requestBody = {
      shareableLinkId: shareableLinkId,
      numberOfColumnToShow: numberOfColumnToShow,
      isShowProfile: isShowProfile,
    };
    return this.http.post<ResponseObject>(url, requestBody, httpOptions);
  }

  public deletePortfolio(PortfoliolinkId?: string): Observable<ResponseObject> {
    var HttpOptions = this.RequestHeaders();
    var method: string = `/DeletePortfolio/${PortfoliolinkId}`;
    var url: string = environment.BASE_API_PATH + this.api + method
    return this.http.delete<ResponseObject>(url, HttpOptions)
  }

  public saveFavoritePortfolio(saveFavoritePortfolio: SaveFavoratePortfolioRequest[]): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/save-favorite-portfolio';
    const url: string = environment.BASE_API_PATH + this.api + method;
    // const body = { portfolioLinkIds: portfolioLinkIds };
    return this.http.post<ResponseObject>(url, saveFavoritePortfolio, httpOptions);
  }
  public fetchFavoritePortfolios(userId: string): Observable<FavoraitePortfolios[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/fetch-favorite-portfolios/${userId}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<FavoraitePortfolios[]>(url, httpOptions);
  }
  public fetchFavoritePortfoliosProducts(userId: string): Observable<ShareableProductLink[]> {
    const httpOptions = this.RequestHeaders();
    const method: string = `/fetch-favorite-portfolios-products/${userId}`;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ShareableProductLink[]>(url, httpOptions);
  }

}

export class portfolioData {
  Title!: string;
  CreatedDate!: Date;
  Description!: string;
  NoOfProductsAllowedToShare!: number;
  NoOfProducts!: number;
  IsActive!: boolean;
  NumberOfColumnToShow!: number;
  Id!: string;
  IsShowProfile!: boolean;
  SharedByUserId!: string;
  CreatedBy!: string;
  BusinessName!: string;
  ProfilePicture!: string;
  AboutMe!: string;
  ShareById!: string;
  UserName!: string;
  IsSharedByArtist!: boolean;
  PortfolioProductsViewModel!: PortfolioProductViewModel[];
}

export class ShareableProductLink {
  Id!: string;
  NumberOfColumnToShow!: number | null;
  IsShowProfile!: boolean;
  SharedByUserId!: string;
  CreatedBy!: string;
  BusinessName!: string;
  UserName!: string;
  ProfilePicture!: string;
  AboutMe!: string;
  ShareById!: string;
  IsSharedByArtist!: boolean;
  Description?: string
  CreatedDate!: Date;
  PortfolioProductsViewModel!: PortfolioProductViewModel[];
  FavouritePortfolioLinkViewModel?: FavouritePortfolioLink | null;
  ProductIds?: string[];
  Title?: string;
  IsActive!: boolean;
  
}

export interface PortfolioProductViewModel {
  Id: string;
  ArtistProduct: ArtistProductSummary;
  Series: null | string;
  Material: null | string;
  SelectedGlazes: SelectedGlaze[];
  GalleryName: null | string;
  GalleryUrl: null;
}

export interface SelectedGlaze {
  GlazeName: string;
  GlazeDescription: string;
}

export interface ShareableArtistProduct {
  Id: string;
  SerialNumber: string;
  ArtistId: string;
  Category: string;
  SkuId: string;
  SeriesId: string;
  ClayId: string;
  ArtTypeId: string;
  Name: string;
  ArtistShortDescription: string;
  ArtistLongDescription: string;
  ArtistSocialMediaDescription: string;
  ProductImgUrl: string;
  Length: string;
  Width: string;
  Height: string;
  Weight: string;
  ArtistRevenue: string;
  CreatedDate: string;
  IsActive: boolean;
  IsSold: boolean;
  IsConsignedProduct: boolean;
  SelectedGlazes: string;
  ArtistProductLogs: string;
  ArtTypeName: string;
}

export class ShareableProductsResponse {
  ShareableProducts!: ArtistProductSummary[];
  CreatedDate?: Date;
  CreatedBy!: string;
  ShareById!: string;
  AboutMe!: string;
  ProfilePicture!: string;
  BusinessName!: string;
  IsSharedByArtist!: string;
  PortfolioProductsViewModel?: { ArtistProduct: ArtistProductSummary }[];
}

export class SavePortfolioProducts {
  portfolioLinkId!: string;
  productIds!: string[];
}

export class FavoraitePortfolios {
  Id!: number;
  UserId!: string;
  User!: null;
  PortfolioLinkId!: string;
  PortfolioLink!: PortfolioLink;
  CreatedDate!: Date;
}

export class PortfolioLink {
  Id!: string;
  Title!: string;
  NoOfColumnToShow!: number;
  IsShowProfile!: boolean;
  IsActive!: boolean;
  CreatedBy!: string;
  Description!: string;
  ApplicationUser!: ApplicationUser;
  CreatedDate!: Date;
  ModifiedDate!: Date;
  ShareableLinkProducts!: null;
  FavouritePortfolioLinks!: any[];
}

export class SaveFavoratePortfolioRequest {
  portfolioLinkId!: string;
  title!: string;
  description!: string;
  isShow!: boolean;
}


